(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-size-guide-link"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('size-guide-modal')) {
    customElements.define('size-guide-modal', class SizeGuideModal extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('[data-size-guide-open]');
        this.dialog = this.querySelector('[data-size-guide-dialog]');
        this.trigger?.addEventListener('click', () => this.dialog?.showModal());
        this.querySelector('[data-size-guide-close]')?.addEventListener('click', () => this.dialog?.close());
        this.dialog?.addEventListener('click', (event) => { if (event.target === this.dialog) this.dialog.close(); });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
